// extracted by mini-css-extract-plugin
export default {"modal_root":"modal_root___cfZtt"};